const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// ===================================
		//	SECTOR SUGGESTIONS
		// ===================================
		case "SECTOR_SUGGESTION_IN_PROGRESS":
			return {
				...getBasicState(state),
				inProgress: 1
			};

		case "SECTOR_SUGGESTION_HAS_ERROR":
			return {
				...state,
				error: action.error,
				inProgress: 0
			};

		case "SECTOR_SUGGESTION_SUCCESS":
			return {
				...state,
				results: action.data.data.results,
				inProgress: 0
			};

		default:
			return state;
	}
};

/**
 * Returns only the basic necessity of state without all of the errors, success, etc.
 * @param object state
 */
function getBasicState(state) {
	const { error, ...newState } = state;
	return newState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/sectorSuggestions.js